import React, { createContext, FC, useContext } from 'react';
import { Formik, Form, FormikValues } from 'formik';
import { RestricoesCamposFormulario } from 'service/restricao/RestricoesCamposFormulario';


/**********************
  Formulario Context
 **********************/
export interface FormularioContextProps {
  restricoes?: RestricoesCamposFormulario;
  operacao: string;
  carregando: boolean;
}

const FormularioContext = createContext<FormularioContextProps>({
  restricoes: undefined,
  operacao: 'naoDefinido',
  carregando: false
});

export const useFormularioContext = () => {
  return useContext(FormularioContext)
}


/**********************
  Formulário
 **********************/
export interface FormularioProps {
  restricoes?: RestricoesCamposFormulario;
  operacao: string;
  /**
   * As informações do formulário ainda estão sendo carregadas?
   */
  carregando?: boolean

  formik: FormikValues;
  className?: string;
}

export const Formulario: FC<FormularioProps> = (props) => {
  const provider = {
    restricoes: props.restricoes,
    operacao: props.operacao,
    carregando: props.carregando ?? false
  }

  return <>
    <Formik {...props.formik as any}>
    <FormularioContext.Provider value={provider}>
      {/* { props.operacao === OperacaoFormulario.Visualizar 
            ? <div className={props.className}>{ props.children }</div>
            : <Form className={props.className}>{ props.children }</Form>
      } */}
      <Form className={props.className}>{ props.children }</Form>
    </FormularioContext.Provider>
    </Formik>
  </>
}
